import { faIcon } from "@utils/faIcon"

import { ColorBadge } from "@atoms"
import type { ColorBadgeProps } from "@atoms/ColorBadge/ColorBadge.types"

import type { AlertBadgeProps } from "./AlertBadge.types"

export default function AlertBadge(props: AlertBadgeProps) {
    const { status, size, showIcon, isLoading, children } = props

    const badgeIcons = {
        neutral: faIcon({ name: "circle-info", style: "solid" }),
        success: faIcon({ name: "circle-check", style: "solid" }),
        warning: faIcon({ name: "triangle-exclamation", style: "solid" }),
        error: faIcon({ name: "circle-xmark", style: "solid" }),
    }

    const statusToColorScheme: Record<AlertBadgeProps["status"], Partial<ColorBadgeProps["colorScheme"]>> = {
        neutral: "gray",
        success: "jade",
        warning: "amber",
        error: "tomato",
    }

    if (showIcon) {
        return (
            <ColorBadge
                variant="icon"
                size={size}
                isLoading={isLoading}
                icon={badgeIcons[status]}
                colorScheme={statusToColorScheme[status]}
            >
                {children}
            </ColorBadge>
        )
    } else {
        return (
            <ColorBadge variant="default" size={size} isLoading={isLoading} colorScheme={statusToColorScheme[status]}>
                {children}
            </ColorBadge>
        )
    }
}
